import { Button, Container, Grid, TextField } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import UserServiceInstance from '../../services/UserService';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import ITagRegistration from '../../models/ITagRegistration';
import { useNavigate } from 'react-router-dom';
import OntimeBreadcrumb from '../common/OntimeBreadcrumb';

const useStyles = makeStyles((theme) => ({
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    appBarSpacer: theme.mixins.toolbar,
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    }
}));

function RegisterTag() {
    const [tagRegistration, setTagRegistration] = useState<ITagRegistration>({
        tagNumber: '',
        PIN: ''
    });
    const { t } = useTranslation("common");
    const navigate = useNavigate();
    const classes = useStyles();

    const registerTag = async () => {
        await UserServiceInstance.registerTag(tagRegistration);
        navigate("user/tags");
    }

    return (
        <main className={classes.content}>
            <div className={classes.appBarSpacer} />
            <Container maxWidth="lg" className={classes.container}>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <OntimeBreadcrumb nameMap={{ [t('userTags.title')]: '/user/tags' }} current={t('registerTag.registerTag')} />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField id="tagNumber"
                            required
                            label={t("registerTag.tagNumber")}
                            fullWidth={true}
                            value={tagRegistration.tagNumber}
                            onChange={e => {
                                tagRegistration.tagNumber = e.target.value;
                                setTagRegistration(tagRegistration);
                            }} />
                        <TextField id="PIN"
                            required
                            label={t("registerTag.PIN")}
                            fullWidth={true}
                            value={tagRegistration.PIN}
                            onChange={e => {
                                tagRegistration.PIN = e.target.value;
                                setTagRegistration(tagRegistration);
                            }} />
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={e => registerTag()}
                            startIcon={<LockOpenIcon />}
                        >{t("registerTag.registerTag")}</Button>
                    </Grid>
                </Grid>
            </Container>
        </main>
    );

}

export default RegisterTag;
